<template lang="pug">
div
  template(v-if="value && link")
    v-chip(
      :color="color"
      small
      @click.stop="$emit('actionPerformed')"
    )
      slot

  template(v-else-if="value")
    v-chip(
      :color="color"
      small
    )
      slot

  template(v-else)
    slot
</template>

<script>
export default {
  props: {
    value: Boolean,
    link: Boolean,
    color: String,
  }
}
</script>
